import { ReactComponent as PaidIcon } from "assets/icons/PaidIcon.svg";
import { ReactComponent as PendingIcon } from "assets/icons/PendingIcon.svg";
import React, { useEffect, useState } from "react";
import {
  ButtonGroup,
  Cancel,
  Content,
  Header,
  Name,
  Save,
  Status,
  StatusTab,
  TabContent,
  TabPanel,
  UserDetailsTab,
  VerticalLine,
  Wrapper,
} from "./Theme";
import { getCurrency } from "helper/numberFormat";
import { ReactComponent as InstallmentIcon } from "assets/icons/recurring-icon.svg";
import {
  SecondRow,
  // Status,
} from "./Theme";
import ShareIcon from "assets/icons/SharePaymentIcon.svg";
import { PulseLoader } from "react-spinners";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { isEmpty } from "lodash";
import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress } from "@mui/material";
import PreSchoolService from "Lib/API/PreSchool";
import { toastr } from "react-redux-toastr";
import "./ParticipantDrawer.scss";
import { Box, Typography, Skeleton } from "@mui/material";
import UserDetailsTabComponent from "./UserDetailsTabComponent";
const style = {
  fontWeight: "700 !important",
  fontFamily: "'Poppins' !important",
  fontSize: 18,
  color: "#3f4255",
  marginBottom: 10,
};
const heading = {
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: 15,
  color: "#4f4f4f",
};
const content = {
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: 16,
  color: "#4f4f4f",
};
const box = {
  boxShadow: "0 0 50px 0 rgba(82, 63, 105, .15)",
  padding: "15px 20px",
  borderRadius: 11,
};
const SkeletonRow = () => (
  <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
    <Skeleton variant="text" width="40%" height={24} />
    <Skeleton variant="text" width="30%" height={24} />
  </Box>
);
const ParticipantDrawer = ({
  drawerData,
  closeModalCharge,
  closeModal,
  getClassParticipants,
  openModalCharge,
  onSharePaymentLinkClick,
  updateData
}) => {
  const [loading, setLoading] = useState(false);
  const [participantInfo, setParticipantInfo] = useState({});
  const { getAccessTokenSilently } = useAuth0();
  useEffect(() => {
  getEventParticipantById();
}, [updateData]);  
  const getEventParticipantById = async () => {
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const response = await PreSchoolService.getEventParticipantById(
        token,
        drawerData?._id,
      );
      setParticipantInfo(response?.result);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getEventParticipantById();
  }, []);

  const afterUpdatedParticipantHandler = () => {
    closeModal();
    getClassParticipants();
  };
  const [tabType, setTabType] = useState("status");
  return (
    <div className="participantDrawer__container">
      <Box
        className="header"
        sx={{ borderBottom: "1px solid #ccc", pb: 1, mb: "0px !important" }}
      >
        <Box className="title">
          <Typography className="name">
            {participantInfo?.firstName} {participantInfo?.lastName}
          </Typography>
          {participantInfo?.addedBy && (
            <div className="participant__name-tag">
              Added by {participantInfo?.addedBy}
            </div>
            
          )}
        </Box>
      </Box>

      {/* Status */}
      <Box sx={{ mt: 1, mb: 2 }}>
        <Typography style={style}>Status</Typography>
        <Box style={box}>
          {loading ? (
            <SkeletonRow />
          ) : (
            <>
              <Box
                display="flex"
                flexDirection="column" 
                justifyContent="space-between"
                alignItems="center"
                gap="10px"
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography style={heading}>Registration Status</Typography>
                  <Typography style={content}>
                    <Status 
                      type={participantInfo?.registrationStatus || "pending"}
                    >
                      {participantInfo?.registrationStatus || "pending"}
                    </Status>
                  </Typography>
                </div>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {/* User Details  */}
      <Box sx={{ mt: 1, mb: 2 }}>
        <Typography style={style}>User Details</Typography>
        <Box style={box}>
          {loading ? (
            <SkeletonRow />
          ) : (
            <>
              {loading && (
                <Box style={{ ...box, minHeight: 100 }}>
                  <SkeletonRow />
                  <SkeletonRow />
                  <SkeletonRow />
                  <Box display="flex" justifyContent="flex-end" sx={{ mb: 1 }}>
                    <Skeleton variant="text" width="30%" height={24} />
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <Skeleton variant="text" width="30%" height={24} />
                  </Box>
                </Box>
              )}

              {participantInfo && (
                <>
                  <Box
                    display="grid"
                    gridTemplateColumns="160px 1fr"
                    rowGap="12px"
                    columnGap="20px"
                    marginBottom="8px"
                  >
                    <Box display="flex" alignItems="center">
                      <Typography
                        style={{
                          ...heading,
                        }}
                      >
                        First Name
                      </Typography>
                    </Box>
                    <Typography style={content}>
                      {participantInfo?.firstName}
                    </Typography>
                  </Box>
                  <Box
                    display="grid"
                    gridTemplateColumns="160px 1fr"
                    rowGap="12px"
                    columnGap="20px"
                    marginBottom="8px"
                  >
                    <Box display="flex" alignItems="center">
                      <Typography
                        style={{
                          ...heading,
                        }}
                      >
                        Last Name
                      </Typography>
                    </Box>
                    <Typography style={content}>
                      {participantInfo?.lastName ?? "-"}
                    </Typography>
                  </Box>
                  <Box
                    display="grid"
                    gridTemplateColumns="160px 1fr"
                    rowGap="12px"
                    columnGap="20px"
                    marginBottom="8px"
                  >
                    <Box
                      display="grid"
                      gridTemplateColumns="140px auto"
                      rowGap="12px"
                      columnGap="24px"
                      marginBottom="1px"
                    >
                      <Typography
                        style={{
                          ...heading,
                        }}
                      >
                        Email
                      </Typography>
                    </Box>
                    <Typography style={content}>
                      {participantInfo?.email ? participantInfo?.email : "-"}
                      {participantInfo?.email && (
                        <ContentCopyIcon
                          fontSize="inherit"
                          sx={{
                            fontSize: "15px !important",
                            marginLeft: "1px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigator.clipboard.writeText(
                              participantInfo?.email,
                            )
                          }
                        />
                      )}
                    </Typography>
                  </Box>
                  <Box
                    display="grid"
                    gridTemplateColumns="160px 1fr"
                    rowGap="12px"
                    columnGap="20px"
                    marginBottom="8px"
                  >
                    <Box display="flex" alignItems="center">
                      <Typography
                        style={{
                          ...heading,
                        }}
                      >
                        Phone Number
                      </Typography>
                    </Box>
                    <Typography style={content}>
                      {participantInfo?.phone ? participantInfo?.phone : "-"}
                      {participantInfo?.phone && (
                        <ContentCopyIcon
                          fontSize="inherit"
                          sx={{
                            fontSize: "15px !important",
                            marginLeft: "1px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigator.clipboard.writeText(
                              participantInfo?.phone,
                            )
                          }
                        />
                      )}
                    </Typography>
                  </Box>
                  <UserDetailsTabComponent
                    participantInfo={participantInfo}
                    afterUpdatedParticipantHandler={
                      afterUpdatedParticipantHandler
                    }
                  />
                </>
              )}
            </>
          )}
        </Box>
        {loading && (
          <Box sx={{ mt: 1, mb: 2 }}>
            <Typography style={style}>Billing Summary</Typography>
            <Box style={{ ...box, minHeight: 100 }}>
              <SkeletonRow />
              <SkeletonRow />
              <SkeletonRow />
              <Box display="flex" justifyContent="flex-end" sx={{ mb: 1 }}>
                <Skeleton variant="text" width="30%" height={24} />
              </Box>
              <Box display="flex" justifyContent="flex-end">
                <Skeleton variant="text" width="30%" height={24} />
              </Box>
            </Box>
          </Box>
        )}
        {!isEmpty(participantInfo?.transactionInfo?.transactions) && (
          <Box sx={{ mt: 1, mb: 2 }}>
            <Typography style={style}>Billing Summary</Typography>
            <Box style={{ ...box, minHeight: 100 , paddingLeft:'0px', paddingRight:'0px' }}>
              {participantInfo?.transactionInfo?.transactions?.map((el, i) => (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  style={{ paddingLeft:'20px', paddingRight:'20px'}}
                  sx={{ mb: 1 }}
                  key={i}
                >
                  <Box display="flex" alignItems="center" >
                    {/* <span style={{ display: "flex", alignItems: "center" }}>
                      <Status
                        type={el?.status}
                        style={{
                          marginLeft: "5px",
                          marginRight: "5px",
                          justifyContent: "start",
                        }}
                      >
                        {el?.status}
                      </Status> */}
                      <Typography
                        style={{
                          ...heading,
                          color: "rgb(36 85 239)",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => openModalCharge(el?.transactionId)}
                      >
                        {el?.Ledger?.name}
                      </Typography>
                    {/* </span> */}
                    {el?.isInstallment && (
                      <Box>
                        <InstallmentIcon className="ml-2" />
                      </Box>
                    )}
                  </Box>
                  <Typography style={content}>
                    {getCurrency()}
                    {Number(el?.amount ?? 0).toFixed(2)}
                  </Typography>
                </Box>
              ))}
              <hr style={{ marginLeft: "20px",marginRight:"20px" }}/>
               <Box display="flex"  style={{ paddingLeft:'20px', paddingRight:'20px'}} justifyContent="space-between" sx={{ mb: 1 }}>
                <Typography style={{ ...heading, marginRight: 10 }}>
                  Total Billed 
                </Typography>
                <Typography style={content}>
                  {getCurrency()}
                  {Number(
                    participantInfo?.transactionInfo?.totalAmountTransaction ?? 0,
                  ).toFixed(2)}
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between"  style={{ paddingLeft:'20px', paddingRight:'20px'}}  sx={{ mb: 1 }}>
                <Typography style={{ ...heading, marginRight: 10 , }}>
                  Total Paid 
                </Typography>
                <Typography style={{...content, color: "#16A34A",}}>
                  {getCurrency()}
                  {Number(
                    participantInfo?.transactionInfo?.totalPaid ?? 0,
                  ).toFixed(2)}
                </Typography>
              </Box>
               <Box display="flex" justifyContent="space-between" alignItems="center"
   style={{ ...box,backgroundColor: "#EAF1FF",
     paddingLeft:'10px', paddingRight:'10px', marginLeft:'10px', marginRight:'10px',
    borderRadius: "10px"}}  sx={{ mb: 1 }}>
                <Typography style={{ ...content, marginRight: 10 ,color: "#3561DC" }}>
                 Balance Due
                </Typography>
                <Typography style={{...content,color: "#3561DC",}}>
                  {getCurrency()}
                  {Number(
                    (participantInfo?.transactionInfo?.totalAmountTransaction-participantInfo?.transactionInfo?.totalPaid) ?? 0,
                  ).toFixed(2)}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
            {participantInfo?.transactionInfo?.totalAmountTransaction -
          participantInfo?.transactionInfo?.totalPaid >
          0 && (
          <SecondRow
            onClick={() => onSharePaymentLinkClick(drawerData)}
            disabled={loading}
          >
            {loading ? (
              <PulseLoader color={"#fff"} size={"7px"} />
            ) : (
              <>
                <img src={ShareIcon} alt="Share-Payment" /> Share Payment Link
              </>
            )}
          </SecondRow>
        )}
        {loading && (
          <Box sx={{ mt: 1, mb: 2 }}>
            <Typography style={style}>Products</Typography>
            <Box style={{ ...box, minHeight: 100 }}>
              <SkeletonRow />
              <SkeletonRow />
              <SkeletonRow />
              <Box display="flex" justifyContent="flex-end" sx={{ mb: 1 }}>
                <Skeleton variant="text" width="30%" height={24} />
              </Box>
              <Box display="flex" justifyContent="flex-end">
                <Skeleton variant="text" width="30%" height={24} />
              </Box>
            </Box>
          </Box>
        )}

        {!isEmpty(participantInfo?.products) && (
          <Box sx={{ mt: 1, mb: 2 }}>
            <Typography style={style}>Products</Typography>
            <Box style={{ ...box, minHeight: 100 }}>
              {participantInfo?.products?.flatMap((el, i) => {
                const safeVal = (v) => {
                  if (v === null || v === undefined) return 0;
                  if (typeof v === 'object') return v.quantity ?? v.price ?? v.amount ?? '';
                  return v;
                };
                if (el?.variant && typeof el.variant === 'object') {
                  return Object.entries(el.variant).map(([variantName, qty]) => (
                    <Box key={`${i}-${variantName}`} display="flex" justifyContent="space-between" sx={{ mb: 1 }}>
                      <Typography style={heading}>{el?.title} ({variantName})</Typography>
                      <Typography style={content}>{safeVal(qty)}</Typography>
                    </Box>
                  ));
                }
                return (
                  <Box key={i} display="flex" justifyContent="space-between" sx={{ mb: 1 }}>
                    <Typography style={heading}>{el?.title}{el?.variant && typeof el.variant === 'string' ? ` (${el.variant})` : ''}</Typography>
                    <Typography style={content}>{safeVal(el?.quantity ?? el?.amount)}</Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}
    
      </Box>

      {/* <div className="header">
        <div className="title">
          <div className="name">{participantInfo?.firstName} {participantInfo?.lastName}
          {participantInfo?.addedBy && (
            <div className="participant__name-tag">Added by {participantInfo?.addedBy}</div>
          )}
          </div>
       
        </div>
    
      </div> */}
      {/* <div className="TabPanel">
        <div
          className={tabType === 'status' ? 'StatusTab active' : 'StatusTab'}
          onClick={() => setTabType('status')}
        >
          Status
        </div>
        <div className="VerticalLine" />
        <div
          className={
            tabType === 'User Details'
              ? 'UserDetailsTab active'
              : 'UserDetailsTab'
          }
          onClick={() => setTabType('User Details')}
        >
          User Details 
        </div>
        <hr width="1" size="500" />
      </div> */}
      {/* {loading ? (
        <div className="w-100 text-center mt-5">
          <CircularProgress />
        </div>
      ) : tabType === 'status' ? (
        <StatusTabComponent participantInfo={participantInfo} 
         
          
        />
      ) : (
        <UserDetailsTabComponent participantInfo={participantInfo} 
          afterUpdatedParticipantHandler={afterUpdatedParticipantHandler}
        />
      )} */}
    </div>
  );
};

export default ParticipantDrawer;
